import { render, staticRenderFns } from "./WhitelabelSettings.vue?vue&type=template&id=2a90b7c4&scoped=true&"
import script from "./WhitelabelSettings.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelSettings.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelSettings.vue?vue&type=style&index=0&id=2a90b7c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90b7c4",
  null
  
)

export default component.exports